"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const codeMirrorUtils_1 = require("./codeMirrorUtils");
function useRegisterOnChangeWithCodeMirror({ choiceGroups, codeMirrorRef, onChange, onClickTag, }) {
    react_1.useEffect(() => {
        if (codeMirrorRef.current) {
            codeMirrorRef.current.on('change', () => {
                codeMirrorUtils_1.onCodeMirrorChange({
                    codeMirror: codeMirrorRef.current,
                    choiceGroups,
                    onChange,
                    onClickTag,
                });
            });
        }
    }, [codeMirrorRef, onClickTag, choiceGroups, onChange]);
}
exports.default = useRegisterOnChangeWithCodeMirror;
